import { isOnlyPoints, isOnlyPrice, isPriceAndPoints } from '@/domain/Filters'

const categoryOrder = category => {
  switch (category) {
    case 'standard':
      return 1
    case 'loyalty':
      return 2
    case 'package':
      return 3
    default:
      return 4
  }
}

const rateTypeOrder = rateGroup => {
  switch (rateGroup) {
    case 'prepay':
      return 1
    case 'flexible':
      return 2
    default:
      return 3
  }
}

export const categorySort = (a, b) => categoryOrder(a) - categoryOrder(b)

export const rateTypeSort = (a, b) => rateTypeOrder(a) - rateTypeOrder(b)

export function cashFirst (a, b) {
  if ((isOnlyPrice(a) && (isPriceAndPoints(b) || isOnlyPoints(b))) || (isOnlyPoints(a) && isPriceAndPoints(b))) return -1
  if (isOnlyPrice(a) && isOnlyPrice(b)) return a.averagePricing.price.amount - b.averagePricing.price.amount
  if (isPriceAndPoints(a) && isPriceAndPoints(b)) return a.averagePricing.price.amount - b.averagePricing.price.amount
  if (isOnlyPoints(a) && isOnlyPoints(b)) return a.averagePricing.points - b.averagePricing.points
  return 1
}

export function pointsFirst (a, b) {
  if ((isOnlyPrice(a) && (isPriceAndPoints(b) || isOnlyPoints(b))) || (isOnlyPoints(b) && isPriceAndPoints(a))) return 1
  if (isOnlyPrice(a) && isOnlyPrice(b)) return a.averagePricing.price.amount - b.averagePricing.price.amount
  if (isPriceAndPoints(a) && isPriceAndPoints(b)) return a.averagePricing.price.amount - b.averagePricing.price.amount
  if (isOnlyPoints(a) && isOnlyPoints(b)) return a.averagePricing.points - b.averagePricing.points
  return -1
}
